import React from 'react'
import {
  Button,
  Card,
  Modal,
  Col,
  Form,
  Icon,
  Input,Collapse,
  Row,
  TimePicker,
  DatePicker,
  Switch,
  Cascader,
  notification,
} from 'antd'
import Moment from 'moment';
import {connect} from 'react-redux'
import {decode} from 'utf8'
import {updateNotification, fetchNotifications} from 'appRedux/actions/Notifications'
const { TextArea } = Input;
const FormItem = Form.Item

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;
const Panel = Collapse.Panel;
function TimeInfo(time, timeString) {
  console.log(time, timeString);
}

function DateInfo(date, dateString) {
  console.log(date, dateString);
}

class Basic extends React.Component {
  state = {
    visible: false,
    id: '',
    title: '',
    message: '',
    date_to: '',
    date_from: '',

    validateStatus: '',

    validateId: '',
    validateMessage: '',
    validateTitle: '',
    currentImage:'',
    helpId: '',
    helpMessage: '',
    helpTitle: '',
    urlImage:'',
    admin_id: '',

    daterangefrom:'',
    daterangeto:'',
  }
  

  showModal = () => {
    console.log('porop',this.props.dataState.dateFrom,this.props.dataState.dateTo)
    this.setState({
      visible: true,
      id: this.props.recording.id,
      title: this.props.recording.title,
      message: this.props.recording.message,
      date_to: this.props.recording.date_to,
      date_from: this.props.recording.date_from,
      currentImage:this.props.recording.urlImagen,
      daterangefrom:this.props.dataState.dateFrom,
      daterangeto:this.props.dataState.dateTo,
    })
    
  }

  handleCancel = e => {
    
    console.log(this.state);
    this.setState({
      id: '',
      title: '',
      message: '',
      date_to: '',
      date_from:'',
      urlImage:'',
      currentImage:'',

    })

    this.props.fetchNotifications();
    this.setState({visible: false})
 
    if (this.state.message == '') {
      this.setState({validateMessage: '', helpMessage: ''})
    }
    if (this.state.title == '') {
      this.setState({validateTitle: '', helpTitle: ''})
    }
  }

  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: value || 'La notificación se ha editado con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido un error al cambiar la notificación.',
      })
    }
  }

  handlChangeImage= selectorFiles => {
    const file = selectorFiles[0]
    this.setState({urlImage: file})
  }

  onHandleClick = event => {
    event.preventDefault()
    let {id, title, message, date_to, date_from} = this.state
    if (this.state.validateStatus != 'error') {
      if (id && title && message && date_to && date_from != '') {
        this.props.updateNotification(this.state, () => {
          this.props.fetchNotifications()
        })

        this.onNotification('success', 'La notificación se ha editado con éxito')
       

      } else {
        if (this.state.id == '') {
          this.setState({
            validateId: 'error',
            helpId: 'Id es un campo obligatorio.',
          })
        } else {
          this.setState({validateId: '', helpId: ''})
        }
        if (this.state.title == '') {
          this.setState({
            validateTitle: 'error',
            helpTitle: 'Nombre es un campo obligatorio.',
          })
        } else {
          this.setState({validateTitle: '', helpTitle: ''})
        }
        if (this.state.message == '') {
          this.setState({
            validateMessage: 'error',
            helpMessage: 'Precio es un campo obligatorio.',
          })
        } else {
          this.setState({validateMessage: '', helpMessage: ''})
        }
        if (this.state.dateFrom !== '' && this.state.dateTo !== ''){
          console.log(this.state);
          this.props.fetchNotifications()
        }
        this.onNotification(
          'error',
          'Rellene los campos obligatorios',
        )
      }
    } 
  }

  
  onClickDateFrom = (date, dateString) => {
    console.log(dateString);
    this.setState({date_from: dateString})
  }

  onClickDateTo = (date, dateString) => {
    console.log(dateString);
    this.setState({date_to: dateString})
  }


  render() {

    const datet=this.state.date_to
    const datef=this.state.date_from
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          <i className="icon icon-edit" />
        </Button>
        <Modal
          afterClose={() => this.props.fetchNotifications(this.props.dateState )}
          okText="Editar"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >
          <Card className="gx-card" title="Editar notificación">
            <form onSubmit={this.onHandleClick}>
            <Row className="padding-modal">
            <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Fecha desde"
                  >
                    <DatePicker defaultValue={Moment(datef)} renderExtraFooter={() => 'extra footer'} onChange={this.onClickDateFrom} placeholder="Desde:"/>
                  </FormItem>
                </Col>

                <Col lg={12} md={12} sm={12} xs={24}>
                  <FormItem
                    label="Fecha hasta"
                  >
                    <DatePicker defaultValue={Moment(datet)} renderExtraFooter={() => 'extra footer'} onChange={this.onClickDateTo} placeholder="Hasta:"/>

                  </FormItem>
                </Col>

              <Col lg={4} md={4} sm={4} xs={4}>
                  <FormItem
                    label="Titulo"
                    validateStatus={this.state.validateTitle}
                    help={this.state.helpTitle}
                  >
                  </FormItem>
                 </Col>
                 <Col lg={20} md={20} sm={20} xs={20}>
                  
                    <Input
                      required
                      placeholder="Título"
                      value={this.state.title}
                      onChange={event => {
                        this.setState({
                          title: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateTitle: '',
                            helpTitle: '',
                          })
                        } else {
                          this.setState({
                            validateTitle: 'error',
                            helpTitle: 'Título es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                 
                </Col>
                <Col lg={4} md={4} sm={4} xs={4}>
                  <FormItem
                    label="Mensaje"
                    validateStatus={this.state.validateMessage}
                    help={this.state.helpMessage}
                  >
                  </FormItem>
                 </Col>
                 <Col lg={20} md={20} sm={20} xs={20}>
                    <TextArea rows={4} 
                      required
                      placeholder="Mensaje"
                      value={this.state.message}
                      onChange={event => {
                        this.setState({
                          message: event.target.value,
                        })
                        if (event.target.value != '') {
                          this.setState({
                            validateMessage: '',
                            helpMessage: '',
                          })
                        } else {
                          this.setState({
                            validateMessage: 'error',
                            helpMessage: 'Nombre es un campo obligatorio.',
                          })
                        }
                      }}
                    />
                
                </Col>

                
                <Col lg={24} md={24} sm={24} xs={24}>
                  <Card type="inner" title="Imagen" style={{position:'relative',top:'30px'}}>


              <Col lg={19} md={19} sm={19} xs={19}>
            
            <div style={{position:'relative', top: '-15px', transform:' translate(87px, 10px)'}}>
            <img src={`${this.state.currentImage}?${new Date().getTime()}`}  height="100" width="100"/>
            </div>

            <Collapse style={{transform: 'translate(38px, 9px)'}}>
                <Panel header="Seleccionar imagen" key="1">
                        <FormItem
                              
                              labelCol={{xs: 12, sm: 12, lg: 12, md: 12}}
                            >
                          
                            <input
                              type="file"
                              onChange={event => {
                                this.handlChangeImage(event.target.files)
                              }}
                            />
                      
                      </FormItem>
                </Panel>
             </Collapse>
                 </Col>
                 </Card>
                </Col>
              </Row>
            </form>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({ notifications}) {
  return {
 
    notifications,
  }
}
export default connect(
  mapStateToProps,
  { fetchNotifications,updateNotification},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Notification/ModalEdit.js